import {z} from 'zod';
import {PhoneNumber} from './phone-number';

/**
 * Represents an international address
 */
export const Address = z.object({
  street: z.string().nullable(),
  houseNumber: z.string().nullable(),
  postalCode: z.string().nullable(),
  city: z.string().nullable(),
  country: z.string().nullable(),
  recipient: z.string().nullable(),
  postAdditional: z.number().nullable(),
  poBox: z.string().nullable(),
  phoneNumber1: PhoneNumber.nullable(),
  phoneNumber2: PhoneNumber.nullable(),
  phoneNumber3: PhoneNumber.nullable(),
});

export type Address = z.infer<typeof Address>;

export function defaultAddress(): Address {
  return {
    street: null,
    houseNumber: null,
    postalCode: null,
    city: null,
    country: null,
    recipient: null,
    postAdditional: null,
    poBox: null,
    phoneNumber1: null,
    phoneNumber2: null,
    phoneNumber3: null,
  };
}
